export const FILTER_SESSION_KEYS = ['documents.filters', 'search.filters'] as const;
